import styles from './AnimatedLoader.module.css';

const AnimatedLoader = () => {
    return (
        <div className={styles.animated_loader}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.416077" y="0.826996" width="22.6016" height="22.6016" fill="#A7D8EB" />
            </svg>

            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="16.7169" y="0.882904" width="22.6016" height="22.6016" transform="rotate(45 16.7169 0.882904)" fill="url(#paint0_radial_126_4)" />
                <defs>
                    <radialGradient id="paint0_radial_126_4" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(28.0177 0.882904) rotate(90) scale(22.6016)">
                        <stop stopColor="#4FB1D8" />
                        <stop offset="0.5" stopColor="#239DCE" />
                        <stop offset="1" stopColor="#1C7EA5" />
                    </radialGradient>
                </defs>
            </svg>


        </div>
    )
}

export default AnimatedLoader;